import { useState, useEffect, useRef } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';

export const useHideSticky = (isMobile: boolean, target: React.MutableRefObject<HTMLFormElement | HTMLDivElement>) => {
  const [ isStickyShowing, setStickyShowStatus ] = useState(true);

  useIntersectionObserver(
    ([ intersect ]) => {
      if (isMobile) {
        setStickyShowStatus(!intersect.isIntersecting);
      }
    },
    [ target ],
    { threshold: [ 1, 0 ], rootMargin: '-100px 0px -100px 0px' }
  );

  useEffect(() => {
    if (isMobile) {
      setStickyShowStatus(false);
    }
  }, [ isMobile ]);

  return isStickyShowing;
};

export const useShowSticky = (target: React.MutableRefObject<HTMLFormElement | HTMLDivElement>) => {
  const [ isStickyShowing, setStickyShowStatus ] = useState(false);
  const prev = useRef<IntersectionObserverEntry>();

  useIntersectionObserver(
    ([ intersect ]) => {
      let direction;
      if (!intersect.isIntersecting) {
        if (prev.current) {
          direction = prev.current.boundingClientRect.top > intersect.boundingClientRect.top ? 'down' : 'up';
        }
      }
      setStickyShowStatus(intersect.isIntersecting || (direction === 'down'));
      prev.current = intersect;
    },
    [ target ],
    { threshold: [ 1, 0 ], rootMargin: '0px 0px 0px 0px' }
  );

  return isStickyShowing;
};
